import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

type ZoomableImageProps = {
    src: string;
    alt?: string;
    size?: string;
    style?: any;
};

const ZoomableImage: React.FC<ZoomableImageProps> = ({ src, alt, size, style }) => {
    const [isZoomed, setIsZoomed] = useState(false);
    const styles = { cursor: "zoom-in", ...style };

    return (
        <div onClick={(e) => e.stopPropagation()}>
            <img
                src={src}
                onClick={(e) => {
                    setIsZoomed(true);
                    e.stopPropagation();
                }}
                className={`rounded-circle avatar-${size ? size : 'xl'} img-thumbnail user-profile-image`}
                alt={alt || "user-profile"}
                style={styles}
            />

            {isZoomed && (
                <Modal
                    isOpen={isZoomed}
                    toggle={() => setIsZoomed(false)}
                    centered
                    backdrop={true} // allow clicking outside to close
                    className="transparent-modal"
                    contentClassName="bg-transparent border-0 shadow-none"
                >
                    <ModalBody className="d-flex justify-content-center align-items-center p-0" style={{
                        cursor: "zoom-out"
                    }} onClick={() => setIsZoomed(false)}
                    >
                        <div>
                            <img
                                src={src}
                                alt={alt || "Zoomed"}
                            />
                        </div>
                    </ModalBody>
                </Modal>
            )}
        </div>
    );
};

export default ZoomableImage;
